module.exports = __webpack_public_path__ + "static/media/top_shape_6_mob.d1ce3980.svg";